import { createUseStyles, multiply } from '@pushpay/styles';
import { GivingOldTheme } from '@pushpay/theming';
export const useStyles = createUseStyles(theme => {
  const isGivingOld = theme.colors['product-color'] === GivingOldTheme.colors['product-color'];
  return {
    avatarWrap: ({
      deprecated
    }) => {
      const deprecatedStyle = deprecated ? {
        [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
          fontSize: '50px',
          padding: `${theme.SPACING.SMALL} ${theme.SPACING.NONE} ${theme.SPACING.NONE}`,
          width: 'auto'
        }
      } : {};
      return {
        height: '100%',
        marginRight: theme.SPACING.SMALL,
        ...deprecatedStyle
      };
    },
    profileInfoOverflowHidden: ({
      deprecated
    }) => ({
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        textAlign: deprecated ? 'center' : 'unset'
      }
    }),
    profileInfoWrap: ({
      deprecated
    }) => ({
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      minWidth: 0,
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        alignItems: deprecated ? 'center' : 'flex-start'
      }
    }),
    profileLink: ({
      deprecated
    }) => ({
      alignSelf: 'flex-start',
      color: isGivingOld ? theme.colors['palette-blue'] : theme.colors['product-color'],
      fontWeight: 100,
      padding: `${theme.SPACING.GUTTER} 0`,
      textDecoration: 'none',
      '&:hover, &:focus': {
        color: isGivingOld ? theme.colors['palette-blue'] : theme.colors['product-color'],
        outline: 'none',
        textDecoration: 'underline'
      },
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        alignSelf: deprecated ? 'center' : 'flex-start'
      }
    }),
    profileSection: ({
      deprecated
    }) => ({
      display: 'flex',
      height: deprecated ? 'auto' : '120px',
      padding: theme.SPACING.SMALL,
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        alignItems: 'center',
        flexDirection: deprecated ? 'column' : 'row',
        paddingBottom: theme.SPACING.SMALL
      }
    }),
    profileSectionAvatar: {},
    emailText: {
      color: theme.colors['color-text-default'],
      paddingTop: multiply(theme.SPACING.GUTTER, 0.5)
    },
    fullNameText: {
      color: theme.colors['palette-black'],
      font: theme.TYPOGRAPHY.HEADLINE_3
    }
  };
});